import * as utils from './utils';
import axios from 'axios';

const ENV_NAME = window.env_name || 'dev';
const ENV = ENV_NAME === 'dev' ? window.configApi.development : window.configApi.production;

export const CURRENT_ENV = ENV;

const AUTH_KEY_NAME = `application_session_${ENV_NAME}`;
const ROOM_ID_KEY = `application_room_${ENV_NAME}`;
const ROOM_INPUT_KEY = `application_input_${ENV_NAME}`;

export function getSavedToken() {
    let session = utils.getJson(AUTH_KEY_NAME);
    let token = null;
    if (!!session && !!session.expired_at && session.expired_at > new Date().getTime()) {
        token = `${session.token_type} ${session.access_token}`;
    }
    return token;
}

/**
 * 
 * @returns {string}
 */
export function getSavedTableId() {
    return utils.getData(ROOM_ID_KEY);
}

/**
 * 
 * @returns {object}
 */
export function getSavedInputs() {
    return utils.getJson(ROOM_INPUT_KEY);
}

export function getToken() {
    return new Promise(async (resolve, reject) => {
        axios.post(`${ENV.host}/auth/login`, {
            "grant_type": "client_credentials",
            "client_id": `${ENV.client_id}`,
            "client_secret": `${ENV.client_secret}`,
        }).then(async (res) => {
            if (res.status === 200) {
                let _data = res.data;
                _data.expired_at = new Date().getTime() + _data.expires_in;
                utils.setData(AUTH_KEY_NAME, JSON.stringify(_data));
            }
            resolve(res);
        }).catch(reject);
    })
}

/**
 * 
 * @param {string} tableId the game tableId
 */
export function setApplicationRoom(tableId) {
    utils.setData(ROOM_ID_KEY, tableId + '');
}

/**
 * 
 * @param {string} cameraTop camera id
 * @param {string} cameraBillBoard camera id
 */
export function setApplicationInputs(cameraTop, cameraBillBoard) {
    utils.setData(ROOM_INPUT_KEY, JSON.stringify({
        cameraTop: cameraTop || '',
        cameraBillBoard: cameraBillBoard || '',
    }));
}

export function getTables() {
    return new Promise(async (resolve, reject) => {
        if (!getSavedToken()) {
            await getToken();
        }
        axios.request({
            method: 'GET',
            url: `${ENV.host}/api/game-table-service/v1/games/tables?page=1&limit=1000&need_total_count=true&only_count=false&sort=name&dir=ASC`,
            headers: {
                "Authorization": getSavedToken()
            }
        }).then((res) => {
            if (res.status === 200) return resolve(res.data);
            return resolve([]);
        }).catch(reject);
    });

}

export function getTable(id) {
    return new Promise(async (resolve, reject) => {
        if (!getSavedToken()) {
            await getToken();
        }
        axios.request({
            method: 'GET',
            url: `${ENV.host}/api/game-table-service/v1/games/tables/id/${id}`,
            headers: {
                "Authorization": getSavedToken()
            }
        }).then((res) => {
            if (res.status === 200) return resolve(res.data);
            return resolve(null);
        }).catch(reject);
    });
}

export function isSetup() {
    return !!getSavedInputs() && !!getSavedTableId();
}

const BOT_TOKEN = '1569863348:AAHOV1_CfhnI_ilfViIRz83baLv386C-3Fg';
// const BOT_CHAT_ID = '-1001454516943'; // channel:Mockup
// const BOT_CHAT_ID = '-1001624991223'; // channel:[IDN] Urgent Notification

export function sendMessage(message, mute) {
    let params = {
        "chat_id": ENV.chat_id || '-1001454516943', // channel:Mockup
        "text": message + "",
        "allow_sending_without_reply": "True",
        "disable_notification": mute === true ? "True" : "False",
        "parse_mode": "html",
        // "parse_mode": "MarkdownV2",
    };
    return axios.post(`https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`, params);
}

export function sendTelegram(name, rid, vid, reason, mute) {
    sendMessage(
        `<b>${name}</b>: ${reason}
============================
RoomId: <b>${rid}</b>
VideoId: <b>${vid}</b>
Time: ${new Date().toLocaleString()}`, !!mute);
}

window.api = {
    getSavedToken,
    getSavedTableId,
    getSavedInputs,
    getToken,
    setApplicationRoom,
    setApplicationInputs,
    getTables,
    getTable,
    isSetup,
    sendMessage,
    sendTelegram,
}